import {GetRessourcesPath} from './checks/GetRessourcesPath';

export const CustomChecks = () => {
  return (
    <div style={{marginLeft: 16}}>
      <GetRessourcesPath />
    </div>
  );
};
